import React, { Component } from 'react'

import PropTypes from 'prop-types'
import ScrollerComponent from './Scroller.component'

class ScrollerContainer extends Component {
  static propTypes = {
    setOffset: PropTypes.func,
    gridWidth: PropTypes.number,
    handleMobileSwitch: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.distanceMoved = 0
    this.percentMoved = 0
    this.mediaQueryList = null

    this.headers = props.headers.slice()
    // this.headers.shift()

    this.totalWidth = this.headers.reduce((prev, curr) => {
      return prev + curr.width
    }, 0) - this.headers[this.headers.length - 1].width


    if (props.freezeCol && props.freezeCol.enabled) {
      this.totalWidth = this.totalWidth - (((this.headers[0].width) ? this.headers[0].width : 200) + 80)
    }

    if (props.rowActions && props.rowActions.enabled && props.rowActions.width) {
      this.totalWidth = this.totalWidth + props.rowActions.width
    }

    // match media to switch scrolltypes

    // we have to do this because our two scrolling mechanisms are incompatible (fixed vs free scroll)
    // so we load the scroller from clean on re-flow and reset the scrolling at the same time.
    // We also pass the result back up the chain to the core dataset (TODO: possibly rework this to pass state down instead. May be ugly due to the requirement to wait while scroller recalculates position)
    if (window && window.matchMedia) {
      this.mediaQueryList = window.matchMedia('(max-width: 760px)')
      this.mediaQueryList.addListener( this.onMatchMedia )

      this.props.handleMobileSwitch(this.mediaQueryList.matches)
      this.state = {
        mobile: this.mediaQueryList.matches
      }
    }
  }

  onMatchMedia = query => {
    this.props.handleMobileSwitch(query.matches)

    if (query.matches) {
      this.setState({
        mobile: true
      })
    } else {
      // ick, I know. But this ensures the DOM is up to date before non-React code can pick it up
      window.setTimeout(this.handleDrag.bind(this), 200)
      // this.handleDrag();

      this.setState({
        mobile: false
      })
    }
  }

  componentWillUnmount() {
    this.mediaQueryList.removeListener( this.onMatchMedia )
  }

  handleDrag = (evt) => {
    if (!this.scrollHandle) {
      return false
    }
    // calculate the offset to move the scrolled element by.
    // amount to move is the percentage of the scrollbar moved within its container, translated to the scrolled element with the viewport width subtracted
    const offset = this.scrollHandle.getBoundingClientRect().left - this.scrollHandle.parentElement.getBoundingClientRect().left
    const space = this.scrollHandle.parentElement.getBoundingClientRect().width - this.scrollHandle.getBoundingClientRect().width
    const percentMoved = (offset / space) * 100

    this.percentMoved = percentMoved
    this.distanceMoved = ((this.props.gridWidth - this.scrollHandle.parentElement.getBoundingClientRect().width) / 100) * percentMoved

    this.props.setOffset(this.distanceMoved)
  }

  handleScrollLeftClick = (evt) => {
    if (this.percentMoved < 1) {
      return false
    }

    this.percentMoved = this.percentMoved - 10
    if (this.percentMoved < 5) {
      this.percentMoved = 0
    }

    // translate percentage movement back to pixel definition for the parent component
    const distanceMoved = ((this.props.gridWidth - this.scrollHandle.parentElement.getBoundingClientRect().width) / 100) * this.percentMoved

    this.distanceMoved = distanceMoved

    this.props.setOffset(distanceMoved)
    this.setState({
      dragOverride: true
    })

    this.props.analytics.propagateEvent({
      eventType: 'click',
      action: 'Scroll Left',
      type: 'Datatable'
    })
  }

  handleScrollRightClick = (evt) => {
    if (this.percentMoved > 99) {
      return false
    }

    if (!this.scrollHandle) {
      return false
    }

    this.percentMoved = this.percentMoved + 10

    // translate percentage movement back to pixel definition for the parent component
    const distanceMoved = ((this.props.gridWidth - this.scrollHandle.parentElement.getBoundingClientRect().width) / 100) * this.percentMoved

    this.distanceMoved = distanceMoved

    this.props.setOffset(distanceMoved)
    this.setState({
      dragOverride: true
    })

    this.props.analytics.propagateEvent({
      eventType: 'click',
      action: 'Scroll Right',
      type: 'Datatable'
    })
  }

  resetDragOverride = () => {
    this.setState({
      dragOverride: false
    })
  }

  calculateHandleWidth() {
    const percentage = (this.props.datasetWidth / this.props.gridWidth) * 100

    return percentage
  }

  calculateHandlePosition() {
    const percentage = this.percentMoved

    if (!this.scrollHandle) {
      return false
    }

    const offset = ((this.scrollHandle.parentElement.getBoundingClientRect().width - this.scrollHandle.getBoundingClientRect().width) / 100) * percentage

    return offset
  }

  calculateScrollerWidth() {
    const output = {
      paddingLeft: '40px',
      paddingRight: '40px'
    }

    if (this.props.freezeCol) {
      output.paddingLeft = '260px'
      output.paddingRight = '40px'
    }

    return output
  }

  render() {
    const styles = {
      height: '10px',
      backgroundColor: '#f4f4f4',
      borderRadius: '10px',
      width: this.calculateHandleWidth() + '%'
    }

    let position = null

    if (this.state.dragOverride) {
      position = {
        x: this.calculateHandlePosition(),
        y: 0
      }
    }

    const { headers, setOffset, rowActions, analytics } = this.props

    const events = {
      handleScrollLeftClick: this.handleScrollLeftClick,
      handleScrollRightClick: this.handleScrollRightClick,
      handleDrag: this.handleDrag,
      resetDragOverride: this.resetDragOverride
    }

    const { mobile } = this.state

    const scrollHandle = (
      <div style={styles} ref={(scrollHandle) => { this.scrollHandle = scrollHandle }} />
    )

    return (
      <ScrollerComponent
        analytics={analytics}
        rowActions={rowActions}
        events={events}
        width={this.calculateScrollerWidth()}
        position={position}
        mobile={mobile}
        scrollHandle={scrollHandle}
        headers={headers}
        setOffset={setOffset}
      />
    )
  }
}

export default ScrollerContainer
